import React from 'react';
import { Tag } from 'antd';

const MethodTag = ({ method, style }) => {
  const displayColorTag = (method) => {
    if (method) {
      const parsedMethod = method.toUpperCase()
      switch (parsedMethod) {
        case "GET":
          return "blue"
        case "POST":
          return "green"
        case "PUT":
          return "volcano"
        case "DELETE":
          return "cyan"
        case "PRIVATE":
          return "red"
        case "PUBLIC":
          return "green"
        default:
          return "purple"
      }
    }
    return "purple"
  }
  return (
    <Tag color={displayColorTag(method)}>
      <p style={{ fontSize: 14, marginBottom: 0, ...style }}>
        {method}
      </p>
    </Tag>
  )
}

export default MethodTag